<script setup>
const asset = (path) => `${import.meta.env.BASE_URL}${path}`

const topItems = [
  { icon: asset('side-bar/main.svg'), label: 'Home', active: true },
  { icon: asset('side-bar/category-livecasino.svg'), label: 'Live casino' },
  { icon: asset('side-bar/category-casino.svg'), label: 'Casino' },
  { icon: asset('side-bar/category-sports.svg'), label: 'Sports' },
]

const bottomItems = [
  { icon: asset('side-bar/category-wheel.svg'), label: 'Wheel' },
  { icon: asset('side-bar/category-promotion.svg'), label: 'Promotions' },
  { icon: asset('side-bar/category-loyalty.svg'), label: 'Loyalty' },
]

const utilityItems = [
  { icon: asset('side-bar/support.svg'), label: 'Support' },
  { icon: asset('side-bar/language.png'), label: 'Language' },
]
</script>

<template>
  <aside class="app-sidebar" aria-label="Sidebar navigation">
    <nav class="app-sidebar__nav" aria-label="Main sections">
      
      <!-- верх + середина -->
      <div class="app-sidebar__main">
        <img class="app-sidebar__divider" :src="asset('Union.svg')" alt="" aria-hidden="true" />

        <button
          v-for="item in topItems"
          :key="item.label"
          class="app-sidebar__button"
          :class="{ 'app-sidebar__button--active': item.active }"
          type="button"
          :aria-label="item.label"
        >
          <img :src="item.icon" alt="" aria-hidden="true" />
        </button>

        <img class="app-sidebar__divider" :src="asset('Union.svg')" alt="" aria-hidden="true" />

        <button
          v-for="item in bottomItems"
          :key="item.label"
          class="app-sidebar__button"
          type="button"
          :aria-label="item.label"
        >
          <img :src="item.icon" alt="" aria-hidden="true" />
        </button>
      </div>

      <!-- низ -->
      <div class="app-sidebar__utility">
        <button
          v-for="item in utilityItems"
          :key="item.label"
          class="app-sidebar__button app-sidebar__utility-button"
          type="button"
          :aria-label="item.label"
        >
          <img :src="item.icon" alt="" aria-hidden="true" />
        </button>
      </div>

    </nav>
  </aside>
</template>

<style scoped>
.app-sidebar {
  display: none;
}

@media (min-width: 768px) {
  .app-sidebar {
    position: fixed;
    top: var(--app-header-height);
    left: 0;
    z-index: 15;
    display: block;
    width: var(--app-sidebar-width);
    height: calc(100vh - var(--app-header-height));
    background: var(--color-sidebar-bg);
    border-right: 1px solid rgb(255 255 255 / 0.24);
  }

  .app-sidebar__nav {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    padding: 30px 0 24px;
  }

  .app-sidebar__main,
  .app-sidebar__utility {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .app-sidebar__utility {
    margin-top: auto;
  }

  .app-sidebar__divider {
    width: 40px;
    height: 6px;
    margin: 0 0 2px;
  }

  .app-sidebar__button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    padding: 0;
    border: 1px solid transparent;
    border-radius: 8px;
    background: transparent;
    cursor: pointer;
    transition: background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  }

  .app-sidebar__button img {
    width: 25px;
    height: 25px;
    object-fit: contain;
  }

  .app-sidebar__button--active {
    border-color: var(--gradient-border-to);
    box-shadow: inset 0 0 0 1px rgb(153 103 41 / 0.35);
  }

  .app-sidebar__button:hover {
    background: var(--color-control-hover);
  }

  .app-sidebar__utility-button {
    background:
      var(--gradient-background) padding-box,
      var(--gradient-border) border-box;
  }

  .app-sidebar__utility-button:hover {
    background:
      var(--gradient-background-hover) padding-box,
      var(--gradient-border-hover) border-box;
    box-shadow: var(--shadow-control-hover);
  }
}
</style>
